import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "utils/Const";
import {
  IApiResponse,
  IGetByIdRequest,
  IGetPrepareDetailRequest,
  IPaginateApiResponse,
  IPaginationRequest,
  IPrepare,
  IPrepareDetail,
  IUpdatePrepareDocumentRequest,
} from "model";
const prefix = PREFIX.receive;

const GET_ALL_PREPARE_DOCUMENTS_URL = `${prefix}/get-prepare-document`;
const URL_GET_PREPARE_DOCUMENT_BY_ID = `${prefix}/get-prepare-document-by-id`;
const GET_PREPARE_DOCUMENT_DETAIL_URL = `${prefix}/get-prepare-document-detail`;
const URL_UPDATE_PREPARE_DOCUMENT = `${prefix}/update-prepare-document`;

class PrepareApiService extends BaseApiService {
  public getAllPrepareDocuments = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IPrepare[]>>(GET_ALL_PREPARE_DOCUMENTS_URL, {
      params: request,
    });
  public getPrepareDocumentById = (request: IGetByIdRequest) =>
    this.get<IApiResponse<IPrepare>>(URL_GET_PREPARE_DOCUMENT_BY_ID, {
      params: request,
    });
  public getPrepareDocumentDetail = (request: IGetPrepareDetailRequest) =>
    this.get<IPaginateApiResponse<IPrepareDetail[]>>(
      GET_PREPARE_DOCUMENT_DETAIL_URL,
      {
        params: request,
      }
    );
  public updatePrepareDocument = (request: IUpdatePrepareDocumentRequest) =>
    this.put<IUpdatePrepareDocumentRequest, IApiResponse<IPrepare>>(
      URL_UPDATE_PREPARE_DOCUMENT,
      request
    );
}

export default new PrepareApiService(true);
